/**
 * SDK del Módulo Verificaciones — Sistema de Perfiles ConstruLink.
 * Endpoints /api/perfil/verificaciones/*
 */

import { api } from "./api";

export async function fetchResumenVerificaciones() {
  const { data } = await api.get("/perfil/verificaciones");
  return data;
}

export async function solicitarOTP(tipo, destino) {
  const { data } = await api.post("/perfil/verificaciones/otp/solicitar", {
    tipo,
    ...(destino ? { destino } : {}),
  });
  return data;
}

export async function confirmarOTP(tipo, codigo) {
  const { data } = await api.post("/perfil/verificaciones/otp/confirmar", { tipo, codigo });
  return data;
}

export async function solicitarVerificacionDocumento(payload) {
  const { data } = await api.post("/perfil/verificaciones/documento", payload);
  return data;
}

export async function solicitarVerificacionEmpresa(payload) {
  const { data } = await api.post("/perfil/verificaciones/empresa", payload);
  return data;
}

export async function solicitarVerificacionProfesional(payload) {
  const { data } = await api.post("/perfil/verificaciones/profesional", payload);
  return data;
}

// Admin
export async function fetchPendientesAdmin() {
  const { data } = await api.get("/perfil/verificaciones/admin/pendientes");
  return data;
}

export async function revisarVerificacion(id, accion, motivo) {
  const { data } = await api.post(`/perfil/verificaciones/admin/${id}`, { accion, motivo });
  return data;
}
